import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  scrollTo?: string;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  scrollTo,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'AddToCart');
      }
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
        return;
      }
    }
    onClick?.();
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative group overflow-hidden rounded-xl font-bold text-lg md:text-xl
        bg-gradient-to-r from-amber-500 to-amber-400 text-amber-950
        px-8 py-4 md:px-10 md:py-5 shadow-[0_0_40px_-10px_rgba(245,158,11,0.5)]
        animate-pulse-gold transition-all duration-300
        hover:shadow-[0_0_60px_-15px_rgba(245,158,11,0.7)]
        hover:from-amber-400 hover:to-amber-300
        ${className}
      `} data-id="element-1">
      <div className="absolute inset-0 bg-white/20 translate-y-[-100%] group-hover:translate-y-[100%] transition-transform duration-700 ease-in-out" data-id="element-2" />
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-3">
        {children}
      </span>
    </motion.button>;
}